module.exports = __webpack_public_path__ + "static/media/pink-logo.b99dcbfc.png";